var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.isOpen)?_c('div',{class:[_vm.popperClass, 'popover', _vm.theme],style:(_vm.popoverMenuStyle),attrs:{"refId":_vm.refId},on:{"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }